import { Component, EventEmitter, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-call-files',
  templateUrl: './call-files.component.html',
  styleUrls: ['./call-files.component.scss']
})
export class CallFilesComponent implements OnInit {
  @Output() filesIncuded = new EventEmitter<FileList>();

  private acceptMimeTypes = [
    "image/x-png",
    "image/gif",
    "image/jpeg",
    "application/pdf",
    "application/json",
    "application/xml",
    "image/webp",
    "text/csv",
    "text/xml",
    "text/plain",
    ".zip",
    ".rar"
  ];

  constructor() { }

  ngOnInit(): void {
  }

  get mimeTypes(): string {
    return this.acceptMimeTypes.join(',');
  }

  public uploadFiles(event) {
    this.filesIncuded.emit(event.target.files);
  }
}
